import formAppConfig from './formAppConfig';
import formConfigLanguage from './formConfigLanguage';

export default {
  title: 'White Label Play Config Form',
  idAttribute: 'id',
  idUpdate: false,
  createURL: 'appId/appConfigsPlay',
  updateURL: 'appId/appConfigsPlay',
  removeURL: 'appId/appConfigsPlay',
  attributeName: 'appConfig',
  sessionParams: ['appId'],
  formConfig: [formAppConfig, formConfigLanguage],
  formGroupExpands: false,
  autoUpdate: false,
  noArea: true,
  goBack: true,
  goBackUrl: '/wlplay/appSlug/configs',
  sessionParams: ['appId', 'appSlug'],
};

